module.exports = {
  title: 'Stacked Carousel with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2025-08-26',
  slug: 'stacked-carousel',
  tags: ['reanimated'],
};
